import { Typography, Box } from "@mui/material";
import JsonEditorAce from "../../../components/code/ace/json.editor";
import { useEffect, useState } from "react";
import TemplateEditorAce from "../../../components/code/ace/template.editor";
import { Create, FileField, List, Show, ShowButton, SimpleForm, SimpleShowLayout, TextField, TextInput, useDataProvider, useRecordContext } from "react-admin";
import DataGridExtended from "../../../components/list/data.grid.extended";
import { useAppDataContext } from "../../../framework/app/app.data.context";
import FileInput from "../../../components/file/FileInput";
import { getConfig } from "../../../framework/config/app.config";

const csApiUrl = getConfig('VITE_BASE_URL');

export const AIFileInstanceList = (props) => (
  <List {...props} resource="aifileinstance" actions={null}>
    <DataGridExtended rowClick="edit" title={"Files"}>
      <TextField label="Name" source="name" />
      <TextField label="User" source="userDisplayName" />
    </DataGridExtended>
  </List>
);

export const AIFileInstanceShow = (props) => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="name" />
        <TextField source="userDisplayName" />
      </SimpleShowLayout>
    </Show>
  );
};

export const AIFileInstanceCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput label="Name" source="name" />
      <TextInput label="Description" source="description" />
      <FileInput source="fileContent" label="Upload File" accept="">
        <FileField source="src" title="title" />
      </FileInput>
    </SimpleForm>
  </Create>
);



// Open AI does not allow the download of files for assistants. we may later store the file content in mongo, leaving this option here.
const FileContentLoader = () => {
  const record = useRecordContext(); // Now inside the correct context
  const { appContext } = useAppDataContext();
  const [fileContent, setFileContent] = useState("");

  useEffect(() => {
    const getFileContent = async () => {
      if (!appContext?.httpClient || !record?.id) return;

      const { httpClient } = appContext;

      try {
        const apiUrl = `${csApiUrl}/ai/streamFile/${record.externalId}`;
        console.log('apiUrl', apiUrl);
        const { body } = await httpClient(apiUrl);
        console.log('body', body);
        const data = JSON.parse(body);
        setFileContent(data);
      } catch (error) {
        console.error("Failed to fetch config:", error);
      }
    };

    getFileContent();
  }, [record?.id, appContext]);

  if (!record) {
    return <div>Loading...</div>; // Handle the loading state
  }

  return <TemplateEditorAce value={fileContent} onChange={undefined} />;
};